import {
    GET_LABS_LIST_REQUEST,
    GET_LABS_LIST_SUCCESS,
    GET_LABS_LIST_FAIL,
    GET_BLOCKED_LIST_REQUEST,
    GET_BLOCKED_LIST_SUCCESS,
    GET_BLOCKED_LIST_FAIL,
    GET_ALLLABS_LIST_REQUEST,
    GET_ALLLABS_LIST_SUCCESS,
    GET_ALLLABS_LIST_FAIL,
    DELETE_LAB_REQUEST,
    DELETE_LAB_SUCCESS,
    GET_REVIEWS_REQUEST,
    GET_REVIEWS_SUCCESS,
    GET_REVIEWS_FAIL,
    GET_EQA_REQUEST,
    GET_EQA_SUCCESS,
    GET_EQA_FAIL,
    DELETE_LAB_FAIL,
    UNBLOCK_LAB_REQUEST,
    UNBLOCK_LAB_SUCCESS,
    UNBLOCK_LAB_FAIL,
    DELETEP_LAB_REQUEST,
    DELETEP_LAB_SUCCESS,
    DELETEP_LAB_FAIL,
    VERIFY_LAB_REQUEST,
    VERIFY_LAB_SUCCESS,
    VERIFY_LAB_FAIL,
    UPDATE_LAB_REQUEST,
    UPDATE_LAB_SUCCESS,
    UPDATE_LAB_FAIL,
    GET_LAB_DETAIL,
    GET_LAB_DETAIL_FAIL,
    GET_LAB_DETAIL_SUCCESS,
    UPLOAD_REQUEST,
    UPLOAD_PROGRESS,
    UPLOAD_SUCCESS,
    UPLOAD_FAILURE,

} from './actionTypes';


//GET LAB LIST
export const getLabsListRequest=()=>{
    return{
        type:GET_LABS_LIST_REQUEST,
    }
}
export const getLabsListSuccess=(tests)=>{
    return{
        type:GET_LABS_LIST_SUCCESS,
        payload:tests,
    }
}
export const getLabsListFail=(error)=>{
    return{
        type:GET_LABS_LIST_FAIL,
        payload:error,
    }
}
export const getBlockedListRequest=()=>{
    return{
        type:GET_BLOCKED_LIST_REQUEST,
    }
}
export const getBlockedListSuccess=(labs)=>{
    return{
        type:GET_BLOCKED_LIST_SUCCESS,
        payload:labs,
    }
}
export const getBlockedListFail=(error)=>{
    return{
        type:GET_BLOCKED_LIST_FAIL,
        payload:error,
    }
}
export const getReviewsListRequest=id =>{
  return{
      type:GET_REVIEWS_REQUEST,
      payload:id
  }
}
export const getReviewsListSuccess=(reviews)=>{
  return{
      type:GET_REVIEWS_SUCCESS,
      payload:reviews,
  }
}
export const getReviewsListFail=(error)=>{
  return{
      type:GET_REVIEWS_FAIL,
      payload:error,
  }
}
export const getEqaListRequest=id =>{
  return{
      type:GET_EQA_REQUEST,
      payload:id
  }
}
export const getEqaListSuccess=(eqas)=>{
  return{
      type:GET_EQA_SUCCESS,
      payload:eqas,
  }
}
export const getEqaListFail=(error)=>{
  return{
      type:GET_EQA_FAIL,
      payload:error,
  }
}
export const getPendingDetail = projectId => ({
    type: GET_PROJECT_DETAIL,
    projectId,
  })
  
  export const getPendingDetailSuccess = projectDetails => ({
    type: GET_PROJECT_DETAIL_SUCCESS,
    payload: projectDetails,
  })
  
  export const getPendingDetailFail = error => ({
    type: GET_PROJECT_DETAIL_FAIL,
    payload: error,
  })

  //GET  All LAB LIST
export const getAllLabsListRequest=()=>{
    return{
        type: GET_ALLLABS_LIST_REQUEST,
    }
}
export const getAllLabsListSuccess=(labs)=>{
    return{
        type:GET_ALLLABS_LIST_SUCCESS,
        payload:labs,
    }
}
export const getAllLabsListFail=(error)=>{
    return{
        type:GET_ALLLABS_LIST_FAIL,
        payload:error,
    }
}

//BLOCK LAB
export const deleteLabRequest = lab => ({
    type: DELETE_LAB_REQUEST,
    payload: lab,
  })
  
  export const deleteLabSuccess = lab => ({
    type: DELETE_LAB_SUCCESS,
    payload: lab,
  })
  
  export const deleteLabFail = error => ({
    type: DELETE_LAB_FAIL,
    payload: error,
  })
  //UNBLOCK LABS
export const unblockLabRequest = lab => ({
    type: UNBLOCK_LAB_REQUEST,
    payload: lab,
  })
  
  export const unblockLabSuccess = lab => ({
    type: UNBLOCK_LAB_SUCCESS,
    payload: lab,
  })
  
  export const unblockLabFail = error => ({
    type: UNBLOCK_LAB_FAIL,
    payload: error,
  })
  //DELETE LAB
export const deletepLabRequest = lab => ({
    type: DELETEP_LAB_REQUEST,
    payload: lab,
  })
  
  export const deletepLabSuccess = lab => ({
    type: DELETEP_LAB_SUCCESS,
    payload: lab,
  })
  
  export const deletepLabFail = error => ({
    type: DELETEP_LAB_FAIL,
    payload: error,
  })
//VERIFY LAB
export const verifyLabRequest = lab => ({
    type: VERIFY_LAB_REQUEST,
    payload: lab,
  })
  
  export const verifyLabSuccess = lab => ({
    type: VERIFY_LAB_SUCCESS,
    payload: lab,
  })
  
  export const verifyLabFail = error => ({
    type: VERIFY_LAB_FAIL,
    payload: error,
  })

  //GET LAB DETAILS
  export const getLabDetail = email => ({
    type: GET_LAB_DETAIL,
    payload: email,
    
  }
  );
  
  export const getLabDetailSuccess = lab => ({
    type: GET_LAB_DETAIL_SUCCESS,
    payload: lab,
  });
  
  export const getLabDetailFail = error => ({
    type: GET_LAB_DETAIL_FAIL,
    payload: error,
  });

  //UPDATE TEST
export const updateLabRequest = (lab,email) => ({
  type: UPDATE_LAB_REQUEST,
  payload: {lab,email},
})

export const updateLabSuccess = lab => ({
  type: UPDATE_LAB_SUCCESS,
  payload: lab,
})

export const updateLabFail = error => ({
  type: UPDATE_LAB_FAIL,
  payload: error,
})

//UPLOAD FILE
export const uploadRequest = (file, email) => ({
  type: UPLOAD_REQUEST,
  payload: {file,email}
});
export const uploadProgress = (file, progress) => ({
  type: UPLOAD_PROGRESS,
  payload: progress,
  meta: { file },
});
export const uploadSuccess = (file) => ({
  type: UPLOAD_SUCCESS,
  meta: { file },
  payload: file,
});
export const uploadFailure = (file, err) => ({
  type: UPLOAD_FAILURE,
  payload: err,
  error: true,
  meta: { file },
});